import type { FC } from 'react';

import { IconTooltip } from 'Components/shared/IconTooltip';
import { T } from 'Features/SellerCommunications/utils/translate';
import { triggerSellerMessagingRepliesSentToTooltipHoveredEvent } from 'Services/analytics/events';
import useUser from 'Utilities/hooks/useUser';

import styles from './EmailForm.module.scss';

export const EmailFromSection: FC = () => {
	const user = useUser();

	return (
		<section className={styles.emailFrom}>
			<label className={styles.label} htmlFor="emailFrom">
				{T.translate('createEmail.emailFrom.label')}
			</label>
			<span className={styles.userEmail}>
				{user?.email}
				<div className={styles.iconWrapper}>
					<IconTooltip
						content={T.translate('createEmail.emailFrom.tooltip')}
						iconProps={{ filled: true, id: 'emailFromTooltip', size: 'xsmall' }}
						maxWidth={'288px'}
						onMouseEnter={triggerSellerMessagingRepliesSentToTooltipHoveredEvent}
						side="top"
					/>
				</div>
			</span>
		</section>
	);
};
